import type { ApiConfig } from '../../types'

/**
 * Backpack の先物実現損益履歴 API 設定。
 * `/wapi/v1/history/settlement` (instruction: settlementHistoryQueryAll) を `source=RealizePnl` で利用する。
 *
 * 本 endpoint は `from` / `to` フィルタをサポートせず、offset ベースの pagination のみ。
 * このため `fetchApiData` 内部で全ページを取得する設計とし、 `limit` には framework の
 * "count < limit ⇒ 全取得済" 判定が常に成立する大きな値を設定する。
 */
export const realizedPnlHistoryApiConfig = {
  existSubType: false,
  fetchableRange: undefined,
  limit: 1_000_000,
  order: 'desc',
  range: undefined,
  requiresRange: false,
  type: 'realized-pnl-history',
} as const satisfies ApiConfig
